import { render, staticRenderFns } from "./AdminMyOrg.vue?vue&type=template&id=c98b70f4"
import script from "./AdminMyOrg.vue?vue&type=script&lang=js"
export * from "./AdminMyOrg.vue?vue&type=script&lang=js"
import style0 from "./AdminMyOrg.vue?vue&type=style&index=0&id=c98b70f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports